var slideContainer = document.querySelector(".icon-text-slider");
var nextBtn = document.querySelector(".next-btn");
var prevBtn = document.querySelector(".prev-btn");

if (slideContainer && nextBtn && prevBtn) {
  // Calculate scroll amount based on the width of .column-slide
  var slidesWidth = document.querySelector(".column-item").offsetWidth;
  var scrollsAmount = slidesWidth + 10; 
  $(nextBtn).click(function () {
    console.log("click");
    slideContainer.scrollBy({
      left: scrollsAmount,
      behavior: "smooth",
    });
  });
  $(".prev-btn").click(function () {
    slideContainer.scrollBy({
      left: -scrollsAmount,
      behavior: "smooth",
    });
  });
} else {
  console.error("One or more elements not found:", {
    slideContainer,
    nextBtn,
    prevBtn,
  });
}
